import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 bg-white" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="bg-brand-cloud border border-brand-gold/40 p-5 sm:p-6 rounded-2xl text-center shadow-sm" data-id="element-85">
          <p className="text-xs sm:text-sm font-extrabold text-brand-blue uppercase tracking-widest mb-2" data-id="element-86">
            Your Investment Is 100% Protected
          </p>
          <div className="w-14 h-14 mx-auto bg-brand-blue/10 rounded-full flex items-center justify-center mb-2" data-id="element-87">
            <ShieldCheckIcon className="w-7 h-7 text-brand-blue" data-id="element-88" />
          </div>
          <h3 className="text-xl sm:text-2xl font-display font-extrabold text-brand-ink mb-3 uppercase" data-id="element-89">
            🛡️ 7-Day Money-Back Guarantee
          </h3>
          <div className="text-sm sm:text-base text-brand-slate font-medium max-w-2xl mx-auto leading-snug space-y-2" data-id="element-90">
            <p data-id="element-91">Your purchase is completely risk-free.</p>
            <p data-id="element-92">
              Take seven full days to explore the entire system, review every
              module, organize your practices, implement the coaching resources,
              and start using the complete planning system with your athletes.
            </p>
            <p data-id="element-93">
              If for any reason you're not completely satisfied, simply contact
              us within the first 7 days and we'll refund 100% of your purchase.
            </p>
            <p className="font-bold text-brand-navy uppercase tracking-wide" data-id="element-94">
              No risk. No questions asked.
            </p>
          </div>
        </div>
      </div>
    </section>;
}